var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKusama(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    width: "24px",
    height: "24px",
    viewBox: "0 0 32 32",
    role: "img",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "social icon for Kusama") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    stroke: "#000",
    strokeMiterlimit: 10,
    d: "M31.96.04H.04v31.92h31.92V.04Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M27.11 9.24c-.38-.3-.83-.7-1.65-.8-.77-.1-1.55.41-2.08.75s-1.53 1.35-1.94 1.65c-.42.3-1.48.59-3.18 1.61-1.7 1.02-8.4 5.32-8.4 5.32l1.74.02-7.76 4h.78l-1.12.85s.98.26 1.81-.26v.24s9.25-3.64 11.03-2.7l-1.09.32 1.85.11a2.5 2.5 0 0 0 1.12 1.8c1.06.7 1.08 1.08 1.08 1.08s-.55.23-.55.51c0 0 .81-.24 1.57-.22a6 6 0 0 1 1.41.22s-.06-.3-.79-.5-1.46-1-1.81-1.44a2.03 2.03 0 0 1-.3-2c.25-.65 1.14-1.01 2.97-1.96 2.15-1.11 2.65-1.94 2.95-2.59.3-.64.76-1.93 1.01-2.53.32-.78.71-1.19 1.04-1.44.32-.24 1.78-.79 1.78-.79s-1.11-.96-1.47-1.25Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKusama);
export default __webpack_public_path__ + "static/media/kusama.03327161bacad1f535584ebde162194d.svg";
export { ForwardRef as ReactComponent };